import { ACTION_TYPES, ITEM_LOCATION_TYPES } from '@/roadmaps/constants/roadmaps.constants';
/* eslint-disable no-restricted-imports */
import store from '@/vuex/store';
import filter from 'lodash/filter';
import find from 'lodash/find';
import reduce from 'lodash/reduce';
import sortBy from 'lodash/sortBy';

export function getPendingForbiddenAction (rootSource, target) {
    return {
        [rootSource.id]: {
            id: rootSource.id,
            type: ACTION_TYPES.FORBIDDEN,
            updates: {},
            preview: false,
            targetItem: target,
        },
    };
}

export function getPendingOutOfBoundsAction (rootSource) {
    return {
        [rootSource.id]: {
            id: rootSource.id,
            type: ACTION_TYPES.OUT_OF_BOUNDS,
            updates: {},
            targetItem: null,
        },
    };
}

export function getPendingResolveActionsForSiblingsForMoveToBacklog (rootSource) {
    const isChild = rootSource.parentType === ITEM_LOCATION_TYPES.INITIATIVE.key;
    if (!isChild) return [];

    const siblings = sortBy(
        filter(
            store.getters['roadmaps/items/itemsByParentId'](rootSource.parentId),
            (sibling) => sibling.id !== rootSource.id,
        ),
        'row',
    );
    const previousSiblingResolveActions = getPendingResolveActionsForNestedItems(siblings);

    return previousSiblingResolveActions;
}

export function getPendingResolveActionsForUnNesting (rootSource, newParentId) {
    const isChild = rootSource.parentType === ITEM_LOCATION_TYPES.INITIATIVE.key;
    const isChangingParent = rootSource.parentId !== newParentId;
    const isUnNesting = isChild && isChangingParent;

    if (!isUnNesting) return [];

    const previousSiblingResolveActions = getPendingResolveActionsForChildren(rootSource.parentId);

    return previousSiblingResolveActions;
}

export function getPendingResolveActionsForChildren (parentId, childToAdd) {
    const children = sortBy(store.getters['roadmaps/items/childItemsWithoutDraggedItem'](parentId), 'row');
    if (childToAdd) {
        children.splice(childToAdd.row, 0, childToAdd);
    }

    return getPendingResolveActionsForNestedItems(children);
}

export function getPendingResolveActionsForNestedItems (nestedItems) {
    return reduce(
        nestedItems,
        (accumulator, targetChild, index) => {
            if (targetChild.row !== index) {
                accumulator.push({
                    id: targetChild.id,
                    type: ACTION_TYPES.RESOLVE,
                    updates: {
                        row: index,
                    },
                    preview: true,
                    targetItem: null,
                });
            }

            return accumulator;
        },
        [],
    );
}

export function getItemLocationTypeByLevel (itemLevel) {
    if (itemLevel === 0) return; // Item cannot be level 0

    return find(ITEM_LOCATION_TYPES, (locationType) => locationType.level === itemLevel).key;
}
